// Import the necessary Firebase modules
import { initializeApp } from "firebase/app";
import {
  connectAuthEmulator,
  EmailAuthProvider,
  getAuth,
  GoogleAuthProvider,
} from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const confg = initializeApp(firebaseConfig);

// init services
// export const analytics = getAnalytics(confg);
export const db = getFirestore(confg);
export const auth = getAuth(confg);
export const storage = getStorage(confg);
export const functions = getFunctions(confg);
export const googleProvider = new GoogleAuthProvider();
export const emailProvider = new EmailAuthProvider();

// config runtime enviroment
if (process.env.REACT_APP_FIREBASE_AUTH_EMULATOR) {
  connectAuthEmulator(auth, process.env.REACT_APP_FIREBASE_AUTH_EMULATOR);
  connectFirestoreEmulator(db, "localhost", 8080);
}
